import { render, staticRenderFns } from "./FieldSchoolInfo.vue?vue&type=template&id=55be639a&scoped=true"
import script from "./FieldSchoolInfo.vue?vue&type=script&lang=js"
export * from "./FieldSchoolInfo.vue?vue&type=script&lang=js"
import style0 from "./FieldSchoolInfo.vue?vue&type=style&index=0&id=55be639a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55be639a",
  null
  
)

export default component.exports